<template>
  <v-layout column align-center>
    <p class="headline font-weight-bold mb-3 text-center primary--text">
      Selecting you notification type
    </p>
    <p class="align-self-start">
      You can choose to be notified using different addresses, such as email addresses or phone numbers. The email you signed up with is automtically set as your default address, however this can be changed. To add an address, simply click on "<v-icon>add_circle_outline</v-icon> New", and you will be prompted to enter a new address. Note that you must be able to enter a verification code to prove you can access the address before proceeding.
    </p>
    <p class="align-self-start">
      If there is more than one type of address available (e.g. email and SMS), the one highlighted in blue will be used
    </p>
    <img v-if="$vuetify.breakpoint.xs" src="@/assets/help/addresses_mobile.png" />
    <img v-else src="@/assets/help/addresses.png" />
    <span class="caption">
      Adding a new address
    </span>
  </v-layout>
</template>

<script>
export default {
  data: () => ({

  }),
};
</script>
<style scoped>
  >>>img {
    border:1px solid black;
    max-width:100%;
  }

  >>>p {
    margin:0 16px;
  }
  >>>span {
    margin:0 16px;
    text-align:center;
  }

  @media screen and (min-width: 600px) {
    >>>img {
      margin:12px;
    }

  }
</style>
